import BaseComponent from '../../base/component';
import { Inject, withAngularComponent } from '../../base/decorators';
import template from './template.html';

const botTypes = {
    CONTEMPLATING: 'CONTEMPLATING',
};

@withAngularComponent({
    name: 'botAvatarComponent',
    bindings: {
        botType: '<',
    },
    template,
    controllerAs: 'ctrl',
})
export class BotTips extends BaseComponent {
    @Inject('$state') $state;

    setupComponentData() {
        this.$scope.imgSrc = this.getBotImageSrc(this.botType);
    }

    getBotImageSrc(botType) {
        switch (botType) {
            case botTypes.CONTEMPLATING:
                return 'assets/img/bot-icons/bot_contemplating.svg';
            default:
                return '';
        }
    }
}
